import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getCardSearchFilterList } from './configFilterStructure';
import { getDataAccordingToGlobalSearchFilters, postActiveFilters } from '../../api/caseDataAPI';
import { exportQuickSearchQueueData } from 'Apis/exportApi';
import GDTable from 'Components/GDTable';
import EmptyState from 'Components/EmptyState/EmptyState';
import { getTranslations } from '../QueueLanding/configStructure';
import { addIconsToGDTableHeadersList } from './configFilterStructure';
import './GlobalSearchLanding.scss';
import HollowButton from 'Components/Button/HollowButton';
import moment from 'moment';
import BVLoader20 from 'Components/loaders/BVLoader/BVLoader20';
import { connect } from 'react-redux';
import { fetchDataColumns } from 'Actions/dataColumnsAction';
import { getToken } from '../../api/tokenizeFilterElement';
import { gotoNewTabCaseLandingPage } from 'Utils/newTabUtils.jsx';
import { downloadFile } from 'Utils/exportFunctionality.js';
import { getAcquirerAccessList } from 'Utils/permissionsUtils';
import {
  dangerNotificationBanner,
  closeNotificationBanner,
} from 'Actions/notificationAction';
import {
  postBookMarkCase,
  undoBookMarkCase,
} from 'Apis/queueManagerApi.js';
import { getSortArray } from 'Utils/sortArrayUtil.js'
import { flushSync } from 'react-dom';


export class GlobalSearchLanding extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isVisible: true,
      filters: [],
      isLoading: true,
      scrollPos: 0,
      totalPages: 0,
      structureMetaData: {},
      caseData: [],
      data: [],
      totalRecords: 0,
      recordsShown: 0,
      currentPage: 0,
      isNextPage: false,
      caseDataErr: false,
      exporting: false,
      filterExportIsVisible: false,
      appliedFilters: [],
      gridSortArray: getCardSearchFilterList().defaultSort,
      dateFormat: getCardSearchFilterList().dateFormat,
      filterText: '',
      savedFilterTranslations: {},
      isRequiredFilter: false,
      isTableVisible: false,
      apiMultiSelectCount: 0,
      multiSelectLength: 0,
      finalFilterElements: [],
      isLoadingComplete: true,
      dataColumns: [],
      globalToken: 0,
      merchantNumber: 0,
      caseNumber: 0,
      cardNumber: 0,
      setSize: false,
      bookMarkedRows: [],
      isBookMarked: false,
      globalToken: '',
      isFirstCall: true,
      isCurrentlySavedFilters:false,
    };
    this.attachBindings();
  }


  attachBindings() {
    this.toggleFilterPane = this.toggleFilterPane.bind(this);
    this.rowActionClick = this.rowActionClick.bind(this);
    this.onRowClick = this.onRowClick.bind(this);
    this.gotoCaseFinder = this.gotoCaseFinder.bind(this);
    this.saveCurrentlyVisibleColumns = this.saveCurrentlyVisibleColumns.bind(this);
    this.getData = this.getData.bind(this);
    this.checkSize = this.checkSize.bind(this);
    this.onBookMarked = this.onBookMarked.bind(this);
  }

  componentWillMount() {
    if (this.props.match !== undefined && this.props.location) {
      this.setState({
        searchkey: this.props.location.state && this.props.location.state.data && this.props.location.state.data.searchkey ? this.props.location.state.data.searchkey : this.props.match.params.searchkey,
        searchType: this.props.match.params.searchType,
      });
      this.props.fetchDataColumns(getCardSearchFilterList(this.props.location.state && this.props.location.state.data && this.props.location.state.data.searchkey ? this.props.location.state.data.searchkey : this.props.match.params.searchkey, this.props.match.params.searchType).pageId);

    }
  }
  componentDidMount() {
    if (this.props.match !== undefined && this.props.match.params && this.props.match.params.searchkey && this.props.match.params.searchType) {
      this.setState({
        searchkey: this.props.match.params.searchkey,
        searchType: this.props.match.params.searchType,
      });
    }
    scroll(0, 0);
  }


  componentWillReceiveProps(nextProps) {
    if (nextProps.match.params.searchType == "caseNumber") {
      this.setState({
        caseNumber: nextProps.match.params.searchkey,
        merchantNumber: 0,
        globalToken: 0,
      });
    }
    else if (nextProps.match.params.searchType == "merchantNumber") {
      this.setState({
        merchantNumber: nextProps.match.params.searchkey,
        globalToken: 0,
        caseNumber: 0,
      });
    }
    else if (nextProps.match.params.searchType == "arn") {
      this.setState({
        arn: nextProps.match.params.searchkey,
        merchantNumber: 0,
        caseNumber: 0,
        globalToken: 0,
      });
    }
    else if (nextProps.match.params.searchType == "wildcard") {
     this.setState({
        arn: nextProps.match.params.searchkey,
        globalToken: 0,
        merchantNumber: nextProps.match.params.searchkey,
        caseNumber: nextProps.match.params.searchkey,
        cardNumber: nextProps.match.params.searchkey,
      });
    }
    if (this.props?.dataColumns?.length !== nextProps.dataColumns?.length
      || (nextProps.location && nextProps.location.state && this.props.location && this.props.location.state && nextProps.location.state.data.searchkey !== this.props.location.state.data.searchkey)
      || this.props.match.params.searchType !== nextProps.match.params.searchType) {

      this.setState({
        dataColumns: addIconsToGDTableHeadersList(nextProps.dataColumns),
        searchkey: nextProps.match.params.searchkey,
        searchType: nextProps.match.params.searchType,
      }, () => {
        if (!this.state.isCurrentlySavedFilters) {
          this.getData(this.props.location.state && nextProps?.location?.state?.data?.searchkey ? nextProps.location.state.data.searchkey : nextProps.match.params.searchkey, nextProps.match.params.searchType, 0, 25, this.state.gridSortArray, false);
        }
      });
    }
  }

  componentWillUpdate(nextProps, nextState) {
    if (nextState.caseData && (this.state.caseData.length !== nextState.caseData.length || this.state.bookMarkedRows.length == 0)) {
      nextState.caseData.map((rowVal) => {
        if (rowVal.bookmarkedBy) {
          this.setState((prevState) => ({
            bookMarkedRows: prevState.bookMarkedRows.concat(rowVal.caseStageId),
          }));
        }
      })
    }
  }
  /**
    This method is responsible for fetching the data related to search key and type.
    params(searchkey:value to search, searchType:Account number or merchant number or casenumber )
   */
  getData(searchkey, searchType, pageNumber, size, sortArray, lazyLoad) {
    this.setState({
      isLoading: true,
    })
    if (searchType === 'accountNumber') {
      getToken(searchkey)
        .then((apiResponse1) => {
          if (apiResponse1.status.statusCode === 2000) {
            this.setState({
              caseDataErr: false,
              isLoading: false,
              globalToken: apiResponse1.data.GlobalToken,
              merchantNumber: 0,
              caseNumber: 0,
            }, () => {
              this.getDataAccordingToSearchFilters(apiResponse1.data.GlobalToken, searchType, pageNumber, size, sortArray, lazyLoad)
            })
          }
        })
    }
    else {
      this.getDataAccordingToSearchFilters(searchkey, searchType, pageNumber, size, sortArray, lazyLoad)
    }
  }

  getDataAccordingToSearchFilters(searchkey, searchType, pageNumber, size, sortArray, lazyLoad) {
    const structureMetaData = searchType === 'accountNumber'? getCardSearchFilterList(this.state.searchkey, searchType) : getCardSearchFilterList(searchkey, searchType);
    structureMetaData.dataColumns = this.state.dataColumns;
    setTimeout(() =>
    this.setState(() => ({
        structureMetaData,
        recordsShown: size,
        caseDataErr: false,
        isLoading: false,
        gridSortArray: [...sortArray],
        isTableVisible: true,
        lazyLoadPageNumber: pageNumber,
        isCurrentlySavedFilters:false,
      })), 500);
  }

  pageHandler = (newPage, newPerPage) => {
    this.setState({
      isLoading: true,
    });

    scroll(0, 0);
    const pageSize = newPerPage === undefined ? this.state.recordsShown : newPerPage;
    if (newPage) {
      this.getData(this.state.searchkey, this.state.searchType, newPage - 1, pageSize, this.state.gridSortArray);
    }
  }

  toggleFilterPane = () => {
    document.body.classList.add('instant-header');
    scroll(0, 0);
    this.setState({
      isVisible: !this.state.isVisible,
    });
  }

  changeDateFormat(field) {
    const dateFormat = 'YYYY/MM/DD';
    return moment(field).format(dateFormat);
  }

  onSearchChange = (filterText) => {
    this.setState({ filterText });
  }

  handleSort = (key) => {
    const newSortArray = this.state.gridSortArray.some(ele => ele.key === key)
      ? this.state.gridSortArray
          .filter(element => element.key === key)
          ?.map(element => ({ key, order: (element.order + 1) % 2 }))
      : [{ key, order: 1 }];
    this.setState({
      currentPage: 1,
      agLoader: true,
      isLoading: true,
      gridSortArray: newSortArray,
    });
    this.getData(this.state.searchkey, this.state.searchType, 0, this.state.recordsShown, newSortArray);
  }

  toggleFileExport = () => {
    this.setState({ filterExportIsVisible: !this.state.filterExportIsVisible, setSize: false });
  }

  onRowClick = (event, sequenceKey) => {
    if ((!event.target.id &&
      !event.target.classList.contains('gd-row-actions') &&
      !event.target.classList.contains('dropdown-menu-trigger')) ||
      event.target.parentNode.classList.contains('primary')) {
      alert(`Row #${sequenceKey} clicked.`); // eslint-disable-line
    }
  }

  rowActionClick(selectedKeyIndex, key) {
    switch (key) {
      case 'OPEN_CASE':
        this.setState({
          selectedKeyIndex,
        });
        this.gotoCaseLandingPage(selectedKeyIndex);
        break;
      case 'OPEN_CASE_IN_TAB':
        gotoNewTabCaseLandingPage(this.state.caseData[selectedKeyIndex].caseNumber);
        break;
      default:
        break;
    }
  }

  onBookMarked(key, rowId) {
    const rowData = rowId;
    let presenceIndex = this.state.bookMarkedRows.findIndex(row => row === rowId);
    if (rowData) {
      if (presenceIndex === -1) {
        return postBookMarkCase(rowData)
          .then(() => {
            this.setState((prevState) => ({
              bookMarkedRows: prevState.bookMarkedRows.concat(rowId),
            }));
          })
          .catch((error) => {

            console.log('Error Occured while Bookmarking the case', error);
          });
      }
      else {
        return undoBookMarkCase(rowData)
          .then(() => {
            this.setState((prevState) => ({
              bookMarkedRows: prevState.bookMarkedRows.filter(row => row !== rowId),
            }));
          })
          .catch((error) => {
            console.log('Error Occured while un-bookmarking the case', error);
          });

      }
    }
  }

  gotoCaseLandingPage(selectedKeyIndex) {
    this.props.history.push({
      state: {
        data: this.state.caseData[selectedKeyIndex],
        prevPath: this.props.location.pathname,
      },
      pathname: '/caselanding/' + `${this.state.caseData[selectedKeyIndex].caseNumber}`,
    });
  }

  gotoCaseFinder() {
    this.props.history.push('/casesearch');
  }

  saveCurrentlyVisibleColumns(columns) {
    this.setState({
      dataColumns: columns,
    });
    const activeDataColumns = [];
    columns.forEach((column) => {
      if (column.displayType !== 'ICON') {
        const activeColumn = {
          columnId: column.columnId,
          displayOrder: column.displayOrder,
        };
        activeDataColumns.push(activeColumn);
      }
    });
    this.postActiveFilters(activeDataColumns);
  }

  postActiveFilters(columns) {
    return postActiveFilters(getCardSearchFilterList(this.state.searchkey, this.state.searchType).pageId, columns)
      .then((apiResponse) => {
        this.props.fetchDataColumns(getCardSearchFilterList(this.state.searchkey, this.state.searchType).pageId);
        this.setState({
          caseDataErr: false,
          isLoading: false,
          isCurrentlySavedFilters:true,
        });
      })
      .catch((error) => {
        this.setState({ caseDataErr: true, isLoading: false });
        console.log('Error Occured while saving active data columns', error);
      });
  }

  exportAction = (fileObject) => {
    this.toggleFileExport();
    let isAllColumns = fileObject.exportType.value === 'all-columns' ? true : false;
    let fileType = fileObject.fileType.value;
    let fileName = fileObject.fileName;
    this.state.totalRecords > 25000 ?
      this.setState({
        setSize: true,
      })
      :
      this.exportFile(fileName, fileType, isAllColumns);
  }
  exportFile(fileName, fileType, isAllColumns) {
    const sortObj = this.state.gridSortArray.map(obj => {
      return {
        fieldId: obj.key,
        orderByProperty: (obj.order) ? 'ASC' : 'DESC',
      }
    })
    let sortKey = [];
    let sortOrder = [];
    let acquirerList = getAcquirerAccessList();

    sortObj.forEach((element) => {
      sortKey.push(element.fieldId);
      sortOrder.push(element.orderByProperty);
    });
    let queueExportData = {
      fileType: fileType,
      isAllColumns: isAllColumns,
      pageId: getCardSearchFilterList(this.state.searchkey, this.state.searchType).pageId,
      quickSearch: {
        caseNumber: this.state.caseNumber,
        dir: sortOrder,
        globalToken: this.state.globalToken,
        merchantNumber: this.state.merchantNumber,
        arn: this.state.arn,
        cardNumber: this.state.cardNumber,
        orderBy: sortKey,
        page: 0,
        size: this.state.totalRecords,
        acquirerAccessList: acquirerList
      }
    }
    this.setState({ exporting: true });
    exportQuickSearchQueueData(queueExportData).then((response) => {
      downloadFile(fileName, fileType, response);
      this.setState({ exporting: false });
    })
      .catch((error) => {
        this.setState({ exporting: false });
        console.log('Error Occured while exporting the case', error);
      });
  }
  checkSize = () => {
    this.props.setNotification([{
      title: `Error Occured`,
      descriptionStyle: "color: 'grey'",
      description: 'Your export request has exceeded the limitation of 25,000 rows.  Please apply additional filters to reduce of number rows.',
      type: 'danger',
      noActions: true,
      cancelOnly: true,
      closeNotification: () => this.props.closeNotification(),
    }]);
    this.setState({
      setSize: false
    })
  }
  loadDataOnScroll = () => {
    if (!(this.state.totalRecords - this.state.data.length <= 0)) {
      this.getDataAccordingToSearchFilters(this.state.searchkey, this.state.searchTypr, this.state.lazyLoadPageNumber + 1, this.state.recordsShown, this.state.gridSortArray, true);
    } else {
      this.setState({
        isLoadingComplete: false,
      });
    }
  };

  setDataError = () => {
    this.setState({
      caseDataErr: true,
    })
  }

  setRecordCount = (recordCount, totalRecords) => {
    this.setState({
      recordsShown: recordCount,
      totalRecords: totalRecords,
    })
  }
  setAggridCaseData = (data, pageNum, sortArray) => {
      this.setState((prevState) => ({
        caseData: (this.state.isFirstCall || pageNum == 1) ? data : prevState.caseData.concat(data),
        isFirstCall: false,
        gridSortArray: sortArray,
    }))
  }
  serverSideData = (props, thisObject, gridColumnApi) => {
    return {
      getRows(params) {
          document.addEventListener('click', (e) => {
            document.isControl = !!e.ctrlKey;
          });

          const newSortArray = params?.api?.getColumnState()
            ?.filter(ele => ele?.sort)
            ?.map(({ colId, sort }) => ({ key:colId, order: sort === 'asc' ? 1 : 0 }));

          let searchValue;
          if(props.filterTypeId == 'wildcard') {
            let searchValue1;
            props.appliedFilterParams.includes("*") ? searchValue1= props.appliedFilterParams.replace("*","%25") : searchValue1 = props.appliedFilterParams.replace("?","%5F").concat("%");
            searchValue = props.filterTypeId === 'accountNumber' ? props.globalToken : searchValue1;
          } else {
              searchValue = props.filterTypeId === 'accountNumber' ? props.globalToken : props.appliedFilterParams;
          }
        let acquirerAccessList = getAcquirerAccessList();
        const totalRecords = thisObject.state?.totalRecords || 0;
        if (!thisObject.state.isSortClicked) {
              const updatedPageNumber = thisObject.state.isColumnChanged ? 0 : thisObject.state.pageNumber;
              return getDataAccordingToGlobalSearchFilters(searchValue, props.filterTypeId, updatedPageNumber, 25, newSortArray, acquirerAccessList)
                .then((apiResponse) => {
                  let count = apiResponse.data.pageable.offset + apiResponse.data.numberOfElements;
                  props.setRecordCount(count, apiResponse.data.totalElements);
                  const formattedData = apiResponse.data.content;
                  const pageNum = updatedPageNumber + 1;
                  props.setAggridCaseData(formattedData, pageNum, newSortArray);
                  flushSync(()=> {
                    thisObject.setState({
                      pageNumber: pageNum,
                      isLoading: false,
                      isSortClicked: false,
                      acquirerAccessList: acquirerAccessList,
                      isColumnChanged: false,
                    })
                  });
                  const isLastPage = apiResponse?.data?.last;
                  const rowCount = isLastPage ? (apiResponse.data.pageable.offset + formattedData.length) : undefined;
                  params.success({
                    rowData: formattedData,
                    rowCount: rowCount,
                  });
                  setTimeout(() => {
                    thisObject.autoSizeAllColumns(params?.api?.getColumnDefs());
                  }, 100);
              })
              .catch((error) => {
                  props.setDataError();
                  flushSync(()=> {
                    thisObject.setState({
                      isSortClicked: false,
                      isColumnChanged: false,
                    })
                  });
                  params.fail();
                  console.log('Error Occured while fetching unmatched case details', error);
              }); 
        } else {
          params.success({
            rowData: [],
            rowCount: totalRecords,
          });
        }
      }
    }
  }
  render() {
    let report = Object.assign({}, this.state.structureMetaData);
    report.dataColumns = Object.assign([], this.state.dataColumns);
    return (
      <section>
        {this.state.setSize == true && this.checkSize()
        }
        <div className={this.props.isSearchActive ? 'main-content--header reports-container--header secondary-header' : "main-content--header reports-container--header"} style={{ zIndex: 3 }}>
          <h1>{getCardSearchFilterList().headerName}</h1>
        </div>
        <div className="main-content--wrapper">
          {this.state.isLoading && <BVLoader20 />}

          {!this.state.isLoading && !this.state.caseDataErr && this.state.dataColumns && this.state?.dataColumns?.length > 0 && <div className="case-search-content" ref={((ref) => (this.gdTable = ref))}>
            <GDTable
              className=""
              report={report}
              data={this.state.data}
              dateFormat={this.state.dateFormat}
              totalPages={this.state.totalPages}
              totalRecords={this.state.totalRecords}
              recordsCountText={{ showingRecords: 'Showing records', preposition: 'of' }}
              currentPage={this.state.currentPage}
              recordsShown={this.state.recordsShown}
              sort={this.state.gridSortArray}
              handleSort={this.handleSort}
              pageHandler={this.pageHandler}
              translations={getTranslations()}
              filterText={this.state.filterText}
              onRowClick={this.onRowClick}
              onSearchChange={this.onSearchChange}
              isNextPage={this.state.isNextPage}
              exporting={this.state.exporting}
              exportAction={this.exportAction}
              filterExportIsVisible={this.state.filterExportIsVisible}
              toggleFileExport={this.toggleFileExport}
              actionButtonText="Actions"
              rowActionClick={this.rowActionClick}
              loadDataOnScroll={this.loadDataOnScroll}
              isLoading={this.state.isLoadingComplete}
              saveCurrentlyVisibleColumns={this.saveCurrentlyVisibleColumns}
              addIconsToGDTableHeadersList={addIconsToGDTableHeadersList}
              openBoxDropDownStyle={{
                width: 150,
                marginLeft: -53,
                fontSize: 'initial',
              }}
              bookMarkedRows={this.state.bookMarkedRows}
              onBookMarked={this.onBookMarked}
              appliedFilterParams={this.state.searchkey}
              filterTypeId={this.state.searchType}
              serverSideData={this.serverSideData}
              setRecordCount={this.setRecordCount}
              isAgGrid={true}
              setDataError={this.setDataError}
              globalToken={this.state.globalToken}
              exportFileName={getCardSearchFilterList().headerName}
              setAggridCaseData={this.setAggridCaseData}
            />
          </div>}
          {this.state.caseDataErr && !this.state.isLoading && (
            <EmptyState
              translations={{ emptyStateHeading: 'Data not available.', emptyStateDescription: 'Please try again later.' }}
            />
          )}
          {!this.state.isLoading && <center>
            Looking for more<br />
            advanced search capabilities?<br />
            <div style={{ marginTop: '10px' }}>
              <HollowButton action={this.gotoCaseFinder}><span style={{ marginLeft: '80px', marginRight: '80px' }}>Case Search</span>                 </HollowButton>
            </div>
          </center>}
        </div>
      </section>
    );
  }
}

GlobalSearchLanding.propTypes = {
  setNotification: PropTypes.func,
  closeNotification: PropTypes.func,
};

GlobalSearchLanding.defaultProps = {

};
const mapStateToProps = (state) => ({
  dataColumns: state.dataColumns?.columns,
  isSearchActive: state.appSearch.isSearchActive,
});

const mapDispatchToProps = (dispatch) => {
  return {
    fetchDataColumns: (pageId) => {
      dispatch(fetchDataColumns(pageId));
    },
    setSearchOpenFlag: (isSearchActive) => {
      dispatch(setSearchOpenFlag(isSearchActive));
    },
    setNotification: (banner) => dispatch(dangerNotificationBanner(banner)),
    closeNotification: () => dispatch(closeNotificationBanner()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GlobalSearchLanding);
